import { lazyImport } from 'utils/LazyImport/LazyImport';
import { ComponentType } from 'react';

export type TRoute = {
  path: string;
  Component: ComponentType;
  queryArguments?: string[];
  redirects?: string[];
  hideMenu?: boolean;
  sorting?: number;
  redirectTo?: string;
};

export const Routes: Record<string, TRoute> = {
  home: {
    path: '/',
    Component: lazyImport(() => import('views/Home/Home')),
  },
  sleepPage: {
    path: '/sleep',
    Component: lazyImport(() => import('views/Sleep/SleepPage')),
  },
  contact: {
    path: '/contact',
    Component: lazyImport(() => import('views/Contact')),
  },
  terms: {
    path: '/terms',
    Component: lazyImport(() => import('views/Terms')),
  },
  imprint: {
    path: '/imprint',
    Component: lazyImport(() => import('views/Imprint')),
  },
  privacy: {
    path: '/privacy',
    Component: lazyImport(() => import('views/Privacy')),
  },
  loginConfirm: {
    path: '/login/:token',
    Component: lazyImport(() => import('views/LoginConfirm')),
    queryArguments: ['token'],
  },
  activationLink: {
    path: '/purchase/connect/:token',
    Component: lazyImport(() => import('views/ActivationLink')),
    queryArguments: ['token'],
  },
  pricing: {
    path: '/pricing',
    Component: lazyImport(() => import('View/Page/PricingPage/PricingPage')),
  },
  billingDetails: {
    path: '/billing_details',
    Component: lazyImport(() => import('views/Payment/BillingDetails/BillingDetails')),
    hideMenu: true,
  },
  paymentMethod: {
    path: '/payment_method',
    hideMenu: true,
    Component: lazyImport(() => import('views/Payment/PaymentMethod/PaymentMethod')),
  },
  summary: {
    path: '/summary',
    hideMenu: true,
    Component: lazyImport(() => import('views/Payment/Summary/Summary')),
  },
  confirmation: {
    path: '/confirmation',
    Component: lazyImport(() => import('views/Payment/Confirmation')),
  },
  confirmationUnknown: {
    path: '/confirmation/unknown',
    Component: lazyImport(() => import('views/Payment/UnkownUserBuy')),
  },
  paymentError: {
    path: '/payment_error',
    Component: lazyImport(() => import('views/Payment/PaymentError')),
  },
  alreadyPaying: {
    path: '/already_paying',
    Component: lazyImport(() => import('views/Payment/AlreadyPaying')),
  },
  resendToken: {
    path: '/resend_token',
    Component: lazyImport(() => import('views/Payment/Pricing/ResendToken/ResendToken')),
  },
  resendTokenB2b: {
    path: '/resend_token/b2b',
    Component: lazyImport(() => import('views/Payment/Pricing/ResendToken/ResendToken')),
    hideMenu: true,
  },
  categoriesFallback: {
    path: '/categories/*',
    Component: lazyImport(() => import('views/AppLinkNotFound')),
  },
  groupsFallback: {
    path: '/groups/*',
    Component: lazyImport(() => import('views/AppLinkNotFound')),
  },
  sleepFallback: {
    path: '/open/sleep/*',
    Component: lazyImport(() => import('views/AppLinkNotFound')),
  },
  gothaerLandingPage: {
    path: '/krankenkasse/gothaer',
    redirects: ['/gothaer'],
    hideMenu: true,
    Component: lazyImport(() => import('views/B2BLandingPages/GothaerLandingpage')),
  },
  zppLandingPage: {
    path: '/krankenkasse',
    hideMenu: true,
    Component: lazyImport(() => import('View/Page/ZppLandingPage/ZppLandingPage')),
  },
  voucherSuccess: {
    path: '/voucher_success',
    hideMenu: true,
    Component: lazyImport(() => import('views/RedeemVoucherSuccess')),
  },
  voucherLandingPage: {
    path: '/voucher',
    hideMenu: true,
    Component: lazyImport(() => import('views/B2BLandingPages/VoucherLandingpage')),
  },
  terminate: {
    path: '/terminate',
    Component: lazyImport(() => import('views/Terminate/Form/TerminateForm')),
  },
  terminateSuccess: {
    path: '/terminate/success',
    Component: lazyImport(() => import('views/Terminate/TerminateSuccess')),
  },
  coopAokBayern: {
    path: '/krankenkasse/aok-bayern',
    Component: lazyImport(() => import('View/Page/CoopAokBayernPage/CoopAokBayernPage')),
  },
  coopAokNordost: {
    path: '/krankenkasse/aoknordost',
    Component: lazyImport(() => import('View/Page/CoopAokNordostPage/CoopAokNordostPage')),
  },
  coopAokBremen: {
    path: '/krankenkasse/aokbremen',
    Component: lazyImport(() => import('View/Page/CoopAokBremenPage/CoopAokBremenPage')),
  },
  coopBigDirect: {
    path: '/krankenkasse/bigdirektgesund',
    Component: lazyImport(() => import('View/Page/CoopBigDirectPage/CoopBigDirectPage')),
  },
  coopIkkClassic: {
    path: '/krankenkasse/ikkclassic',
    Component: lazyImport(() => import('View/Page/CoopIkkClassicPage/CoopIkkClassicPage')),
  },
  coopMkk: {
    path: '/krankenkasse/meine-krankenkasse',
    Component: lazyImport(() => import('View/Page/CoopMkkPage/CoopMkkPage')),
  },
  coopSalusBkk: {
    path: '/krankenkasse/salus-bkk',
    Component: lazyImport(() => import('View/Page/CoopSalusBkkPage/CoopSalusBkkPage')),
  },
  coopVividaBkk: {
    path: '/krankenkasse/vividabkk',
    Component: lazyImport(() => import('View/Page/CoopVividaBkkPage/CoopVividaBkkPage')),
  },
  trustPortal: {
    path: '/security',
    Component: lazyImport(() => import('View/Page/TrustPortalPage/TrustPortalPage')),
  },
};
